import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Location } from '@angular/common';
import { AlertService, GrowlType } from 'app/infrastructure/services/alert.service';
import { QueryBuilderConfig } from 'app/plugins/queryBuilder';
import { RuleBuilderService, EmptyRuleBuilder } from 'app/infrastructure/services/ruleBuilder.service';
import { INgxSelectOption } from 'ngx-select-ex';
import { ProductReportService } from 'app/infrastructure/services/productreport.service';
import { FieldMap } from 'app/plugins/queryBuilder/components';
import { OperationPrototypes, TypeOptions } from 'app/infrastructure/model/interfaces/rulePrototype.interface';
import { MappingProductReportAttribute } from 'app/infrastructure/model/classes/productReport.class';

@Component({
    selector: 'sx-mappingDetails-productReport',
    templateUrl: './mappingDetails.productReport.component.html',
})
export class MappingDetailsProductReportComponent implements OnInit {
    systemCode: string;
    businessCode: string;
    productCode: string;
    productReportCode: string;
    mappingId: string;

    produtReportConst = 'productReportAttribute';
    newConst = 'new';


    attributeModel:
        MappingProductReportAttribute = {
            attribute: '',
            type: 'String',
        };

    // data types
    opciones = TypeOptions;
    sources = [];
    targetKeys = [];
    targetFields = [];

    isNew = false;
    selectedSource = 'documentAttribute';
    operationTypes = OperationPrototypes;
    mapperFields: FieldMap = null;
    loaded = false;

    constructor(
        private aRoute: ActivatedRoute,
        private _router: Router,
        private productReportService: ProductReportService,
        private location: Location,
        private alertService: AlertService,
        private ruleService: RuleBuilderService
    ) { }

    ngOnInit() {
        this.aRoute.params.subscribe((params: Params) => {
            this.productReportCode = params['productReportCode'];
            this.mappingId = params['mappingId'];
            this.systemCode = params['codsistema'];
            this.businessCode = params['codnegocio'];
            this.productCode = params['codproducto'];
      
            this.ruleService.getForProductReportConfiguration(this.systemCode, this.businessCode, this.productCode, this.productReportCode)
                .subscribe(config => {
                    const ff = config.fields;
                    this.sources = Object.keys(config.entities);
                    this.mapperFields = ff;
                    if (this.mappingId !== this.newConst) {
                        this.isNew = false;
                        this.productReportService
                            .getAttribute(this.productReportCode, this.mappingId)
                            .subscribe(data => {
                                this.attributeModel = data;
                                this.loaded = true;
                            });
                    } else {
                        this.isNew = true;
                        this.attributeModel.systemCode = this.systemCode;
                        this.attributeModel.businessCode = this.businessCode;
                        this.attributeModel.productCode = this.productCode;
                        this.attributeModel.productReportCode = this.productReportCode;
                        this.loaded = true;
                    }
                });
        });
    }

    back(): void {
        this.location.back();
    }

    save(): void {
        this.productReportService.saveAttribute(this.attributeModel).then(a => {
            this.alertService.showGrowl({
                type: GrowlType.SUCCESS,
                body: 'PRODUCTREPORT_ATTRIUBUTE_SUCCESS',
            }, { name: a.attribute });
            this.back();
        });
    }

    getChange(event) {
        this.attributeModel.mappingRule = event;
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/product/productReport/mapping/mappingDetails.productReport.component.ts